try {
  (function() {
    if (!window.location || window.location.pathname !== '/pages/oladance-drop') {
      return;
    }

    var AB_NUM_COOKIE = 'abtno';
    var AB_VERSION_COOKIE = 'abtv';
    var COOKIE_DAYS = 30;
    var THRESHOLD = 500;
    var ABTestingV1 = 'oladance_drop_cart_on';
    var ABTestingV2 = 'oladance_drop_cart_off';

    var abtno = getCookie(AB_NUM_COOKIE);
    var abtnoValue = parseFloat(abtno);

    if (!abtno || Number.isNaN(abtnoValue)) {
      abtnoValue = Math.floor(Math.random() * 1000);
      createCookie(AB_NUM_COOKIE, abtnoValue, COOKIE_DAYS);
    }

    var isV2 = abtnoValue < THRESHOLD;
    var variantName = isV2 ? ABTestingV2 : ABTestingV1;

    createCookie(AB_VERSION_COOKIE, variantName, COOKIE_DAYS);
    document.documentElement.setAttribute('data-abt-variant', isV2 ? 'drop-cartless' : 'drop-cart');

    function createCookie(name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    }

    function getCookie(c_name) {
      if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + '=');
        if (c_start !== -1) {
          c_start = c_start + c_name.length + 1;
          var c_end = document.cookie.indexOf(';', c_start);
          if (c_end === -1) {
            c_end = document.cookie.length;
          }
          return decodeURIComponent(document.cookie.substring(c_start, c_end));
        }
      }
      return '';
    }
  })();
} catch (error) {}
